/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_All_DayInputs */

const cs_form_all_day = /** @type {(inputs: Form_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celý den`)
};

const en_form_all_day = /** @type {(inputs: Form_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All day`)
};

/**
* | output |
* | --- |
* | "All day" |
*
* @param {Form_All_DayInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_all_day = /** @type {((inputs?: Form_All_DayInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_All_DayInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_all_day(inputs)
	return cs_form_all_day(inputs)
});